export function getViteAppBugsnagId(): string {
  return import.meta.env.VITE_BUGSNAG_ID;
}
